import { render, staticRenderFns } from "./LagerumschlagEntwicklungView.vue?vue&type=template&id=c143d652&"
import script from "./LagerumschlagEntwicklungView.vue?vue&type=script&lang=js&"
export * from "./LagerumschlagEntwicklungView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports